import React from "react";
import AdminLayout from "../AdminLayout";
import ExpertsSection from "./ExpertsSection";

const Experts = () => {
  return (
    <AdminLayout
      selectedMenuItem="Experts"
      pageTitle="Experts Directory"
      pageSubtitle="Review profiles, expertise, and portfolios with a more readable management view."
    >
      <ExpertsSection />
    </AdminLayout>
  );
};

export default Experts;
